import {STATE_PROP_NAME} from './companies-page-constants'

export const getState = state => state[STATE_PROP_NAME]
